// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ec043909","703":"d9b44add"}[chunkId] + ".chunk.js";
};